export default __webpack_public_path__ + "static/media/ico_adherence.eb5af8f9.svg";